import { IImportModel } from '../importer/model';

export const ancillarySuppliersImportDomainSelector = (state: any): IImportModel =>
  state.ancillarySuppliersImport as IImportModel;
